export const EVENT_DEFAULT = 'default';
